import React from 'react';
import type { AuthSectionProps } from '~/lib/types/netlify';

export const AuthSection = ({ isCheckingToken, tokenCheckCount, onConnect, onAbort }: AuthSectionProps) => {
  return (
    <div className="flex flex-col gap-3">
      <button
        onClick={onConnect}
        disabled={isCheckingToken}
        className="w-full px-6 py-3 bg-gradient-to-b from-alpha-primary-start to-alpha-primary-end 
        rounded-lg text-white text-sm font-medium shadow-md
        hover:brightness-110 transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed 
        flex items-center justify-center gap-2"
      >
        {isCheckingToken ? (
          <>
            <div className="i-ph:circle-notch w-4 h-4 animate-spin mr-2" />
            Connecting to Netlify... ({30 - tokenCheckCount}s)
          </>
        ) : (
          'Connect with Netlify'
        )}
      </button>

      {isCheckingToken && (
        <button
          onClick={onAbort}
          className="w-full px-6 py-2.5 bg-white/5 border border-white/10 
          rounded-lg text-[#e7e7e7] text-sm font-medium 
          hover:bg-white/10 transition-colors"
        >
          Abort Connection
        </button>
      )}
    </div>
  );
};
